export default "__VITE_ASSET__vLKVGWlC__"